import { fetch } from "../../../appContainer";
import {
  GET_SHIPPINGS_LIST_IN_PROGRESS,
  GET_SHIPPINGS_LIST_SUCCESS,
  GET_SHIPPINGS_LIST_FAIL,
  GET_SHIPPINGS_FILTERS_IN_PROGRESS,
  GET_SHIPPINGS_FILTERS_SUCCESS,
  GET_SHIPPINGS_FILTERS_FAIL,
  GET_SHIPPINGS_COUNT_IN_PROGRESS,
  GET_SHIPPINGS_COUNT_SUCCESS,
  GET_SHIPPINGS_COUNT_FAIL,
} from "../constants";

/**
 * Get shippings list
 */
export function getShippingsList(filters = {}) {
  return (dispatch) => {
    dispatch({ type: GET_SHIPPINGS_LIST_IN_PROGRESS });

    fetch("api").getShippingsList(
      filters,
      (list) => {
        dispatch({ type: GET_SHIPPINGS_LIST_SUCCESS, payload: { list } });
      },
      () => dispatch({ type: GET_SHIPPINGS_LIST_FAIL }),
    );
  };
}

export function getShippingsFilters() {
  return (dispatch) => {
    dispatch({ type: GET_SHIPPINGS_FILTERS_IN_PROGRESS });

    fetch("api").getShippingsFilters(
      (filters) => {
        dispatch({ type: GET_SHIPPINGS_FILTERS_SUCCESS, payload: { filters } });
      },
      () => dispatch({ type: GET_SHIPPINGS_FILTERS_FAIL }),
    );
  };
}

export function getShippingsCount(filters = {}) {
  return (dispatch) => {
    dispatch({ type: GET_SHIPPINGS_COUNT_IN_PROGRESS });

    fetch("api").getShippingsCount(
      filters,
      (count) => {
        dispatch({ type: GET_SHIPPINGS_COUNT_SUCCESS, payload: { count } });
      },
      () => dispatch({ type: GET_SHIPPINGS_COUNT_FAIL }),
    );
  };
}
